var selectCallback = function(variant, selector) {
  // CORRECTED SELECTORS for price elements
  const priceEl = document.getElementById('productPrice');
  const comparePriceEl = document.getElementById('comparePrice');
  
  // Other element selectors
  const addToCartBtn = document.getElementById('AddToCart');
  const skuEl = document.querySelector('.variant-sku');
  const productImageEl = document.querySelector('#product-product .thumbnails img');

  if (variant) {
    // This price logic is now more robust and uses the correct selectors
    if (priceEl) {
     const formattedPrice = Shopify.formatMoney(variant.price, window.moneyFormat);

      
      if (variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `<span class="product__price--sale">${formattedPrice}</span>`;
        if (comparePriceEl) {
          comparePriceEl.innerHTML = Shopify.formatMoney(variant.compare_at_price, window.moneyFormat);

          comparePriceEl.style.display = '';
        }
      } else {
        priceEl.innerHTML = formattedPrice;
        if (comparePriceEl) {
          comparePriceEl.style.display = 'none';
        }
      }
    }

    // Update image
    if (variant.featured_image && productImageEl) {
      productImageEl.src = variant.featured_image.src;
    }

    // Update Add to Cart button
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.classList.toggle('disabled', !variant.available);
      addToCartBtn.textContent = variant.available ? 'Add to cart' : 'Sold Out';
    }

    // Update SKU
    if (skuEl) {
      skuEl.textContent = variant.sku ? variant.sku : '';
    }

  } else {
    // Handle case where no variant is found
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Unavailable';
      addToCartBtn.classList.add('disabled');
    }
  }
};